import WithPublicFallback from "../../components/WithPublicFallback/WithPublicFallback";
import WithActiveSubscription from "../../components/WithActiveSubscription/WithActiveSubscription";
import Layout from "../../components/Layout/Layout";
import EventPage from "./Event";
import PublicEventPage from "./PublicEvent";

const EventWithPublicFallback: React.FC = () => {
  return (
    <WithPublicFallback
      authenticatedComponent={
        <WithActiveSubscription>
          <Layout>
            <EventPage />
          </Layout>
        </WithActiveSubscription>
      }
      unauthenticatedComponent={<PublicEventPage />}
    />
  );
};

export default EventWithPublicFallback;
